/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useRef, useState} from 'react'
import ApexCharts, {ApexOptions} from 'apexcharts'
import {Dropdown1} from '../../../../_eLab/partials/content/dropdown/Dropdown1'
import {getCSSVariableValue} from '../../../../_eLab/assets/ts/_utils'
import {KTSVG} from '../../../../_eLab/helpers'
import {Link} from 'react-router-dom'
import {IDashboardModel} from '../../../models/master-page/DashboardModel'
import {getAdminCountApi} from '../../../modules/Dashboard/DashboardCURD'
import {toast} from 'react-toastify'

type Props = {
  className: string
  chartColor: string
  strokeColor: string
  chartHeight: string
}

interface IState {
  loading: boolean
  list: IDashboardModel
}

const MixedWidget2: React.FC<Props> = ({className, chartColor, chartHeight, strokeColor}) => {
  const chartRef = useRef<HTMLDivElement | null>(null)

  let [state, setState] = useState<IState>({
    loading: false,
    list: {} as IDashboardModel,
  })

  // Fetch data once on mount
  useEffect(() => {
    setState((s) => ({...s, loading: true}))
    setTimeout(() => {
      fetchAdminCountList()
    }, 100)
  }, [])

  // Build / rebuild chart whenever the data we feed it changes
  useEffect(() => {
    if (!chartRef.current) {
      return
    }

    const seriesData =
      (state.list as any)?.monthlySeries && Array.isArray((state.list as any).monthlySeries)
        ? (state.list as any).monthlySeries
        : [0, 0, 0, 0, 0, 0, 0]

    const chart = new ApexCharts(
      chartRef.current,
      chartOptions(chartHeight, chartColor, strokeColor, seriesData)
    )

    chart.render()

    return () => {
      chart.destroy()
    }
  }, [chartRef, state.list, chartHeight, chartColor, strokeColor])

  function fetchAdminCountList() {
    getAdminCountApi()
      .then((response) => {
        let responseData = response.data
        if (responseData.isSuccess === true) {
          setState((s) => ({...s, list: responseData, loading: false}))
        } else {
          toast.error(`${responseData.message}`)
          setState((s) => ({...s, list: {} as IDashboardModel, loading: false}))
        }
      })
      .catch((error) => {
        toast.error(`${error}`)
        setState((s) => ({...s, list: {} as IDashboardModel, loading: false}))
      })
  }

  const {list} = state

  const StatCard = ({
    to,
    title,
    count,
    color = 'primary',
  }: {
    to: string
    title: string
    count: number
    color?: 'primary' | 'success' | 'danger' | 'dark' | 'warning' | 'info'
  }) => (
    <div className='col-6 col-md-4'>
      <div className={` border-start border-3 border-${color} p-4 rounded-2 h-100`}>
        <Link to={to}>
          <div className='text-dark text-decoration-none'>
            <div className='fw-bold fs-6'>{title}</div>
          </div>
          <p className={`fs-4 fw-bold text-primary mt-3 mb-0`}>{count}</p>
        </Link>
      </div>
    </div>
  )

  const StattCard = ({
    to,
    title,
    count,
    color = 'primary',
  }: {
    to: string
    title: string
    count: number
    color?: 'primary' | 'success' | 'danger' | 'dark' | 'warning' | 'info'
  }) => (
    <div className='col-6 col-md-4'>
      <div className={` border-start border-3 border-${color} p-4 rounded-2 h-100`}>
        <Link to={to}>
          <div className='text-dark text-decoration-none'>
            <div className='fw-bold fs-6'>{title}</div>
          </div>
          <p className={`fs-4 fw-bold text-primary mt-3 mb-0`}>{count}</p>
        </Link>
      </div>
    </div>
  )

  return (
    <>
      <div className='bg-light py-4'>
        <div className='container'>
          {/* New Orders - By Customer */}
          <div className='card p-4 mb-4 shadow-sm rounded-3'>
            <h4 className='fw-semibold text-dark fs-5 mb-3'>
              New Orders - <span className='text-primary'>By Customer</span>
            </h4>
            <span className='border-1 border-bottom' />
            <div className='row g-4 mt-2 text-center'>
              <StatCard
                to='/order-management/by-customer/test-lab/list'
                title='Test Lab'
                count={list.cusTestLab}
                color='warning'
              />
              <StatCard
                to='/order-management/by-customer/redilogys-home/list'
                title='Radiology Home'
                count={list.cusRedLogyHm}
                color='primary'
              />
              <StatCard
                to='/order-management/by-customer/redilogy-lab/list'
                title='Radiology Lab'
                count={list.cusRedLogyLab}
                color='danger'
              />
              {/* <StatCard
                to='/order-management/by-customer/health-care/list'
                title='Health Care'
                count={list.cusHltCare}
                color='dark'
              /> */}
            </div>
          </div>

          {/* New Orders - By Doctor */}
          <div className='card p-4 mb-4 shadow-sm rounded-3'>
            <h4 className='fw-semibold text-dark fs-5 mb-3'>
              New Orders - <span className='text-primary'>By Doctor</span>
            </h4>
            <span className='border-1 border-bottom' />
            <div className='row g-4 mt-2 text-center'>
              <StattCard
                to='/order-management/by-doctor/test-lab/list'
                title='Test Lab'
                count={list.docTestLab}
                color='success'
              />
              <StattCard
                to='/order-management/by-doctor/redilogys-home/list'
                title='Radiology Home'
                count={list.cusRedLogyHm}
                color='success'
              />
              <StattCard
                to='/order-management/by-doctor/redilogy-lab/list'
                title='Radiology Lab'
                count={list.docTestLab}
                color='info'
              />
            </div>
          </div>

          {/* Orders Status */}
          <div className='card p-4 mb-4 shadow-sm rounded-3'>
            <h4 className='fw-semibold text-primary fs-5 mb-3'>Orders Status</h4>
            <span className='border-1 border-bottom' />
            <div className='row g-4 mt-2 text-center'>
              <StatCard
                to='/countries'
                title='Total Orders'
                count={list.totalOrder}
                color='warning'
              />
              <StatCard to='/states' title='Open Orders' count={list.openOrder} color='primary' />
              <StatCard
                to='/districts'
                title='Close Orders'
                count={list.closeOrder}
                color='danger'
              />
              <StatCard
                to='/districts'
                title='Under Process Orders'
                count={list.process}
                color='dark'
              />
            </div>
          </div>
          <div ref={chartRef} className='mixed-widget-2-chart card-rounded-bottom mt-4' />
        </div>
      </div>
    </>
  )
}

const chartOptions = (
  chartHeight: string,
  chartColor: string,
  strokeColor: string,
  seriesData: number[]
): ApexOptions => {
  const labelColor = getCSSVariableValue('--bs-gray-500')
  const borderColor = getCSSVariableValue('--bs-gray-200')
  const color = getCSSVariableValue('--bs-' + chartColor)

  return {
    series: [
      {
        name: 'Net Profit',
        data: seriesData,
      },
    ],
    chart: {
      fontFamily: 'inherit',
      type: 'area',
      height: chartHeight,
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
      sparkline: {
        enabled: true,
      },
      dropShadow: {
        enabled: true,
        enabledOnSeries: undefined,
        top: 5,
        left: 0,
        blur: 3,
        color: strokeColor,
        opacity: 0.5,
      },
    },
    plotOptions: {},
    legend: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
    fill: {
      type: 'solid',
      opacity: 0,
    },
    stroke: {
      curve: 'smooth',
      show: true,
      width: 3,
      colors: [strokeColor],
    },
    xaxis: {
      categories: ['Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug'],
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        show: false,
        style: {
          colors: labelColor,
          fontSize: '12px',
        },
      },
      crosshairs: {
        show: false,
        position: 'front',
        stroke: {
          color: borderColor,
          width: 1,
          dashArray: 3,
        },
      },
    },
    yaxis: {
      min: 0,
      max: 80,
      labels: {
        show: false,
        style: {
          colors: labelColor,
          fontSize: '12px',
        },
      },
    },
    states: {
      normal: {
        filter: {
          type: 'none',
          value: 0,
        },
      },
      hover: {
        filter: {
          type: 'none',
          value: 0,
        },
      },
      active: {
        allowMultipleDataPointsSelection: false,
        filter: {
          type: 'none',
          value: 0,
        },
      },
    },
    tooltip: {
      style: {
        fontSize: '12px',
      },
      y: {
        formatter: function (val) {
          return '$' + val + ' thousands'
        },
      },
      marker: {
        show: false,
      },
    },
    colors: ['transparent'],
    markers: {
      colors: [color],
      strokeColors: [strokeColor],
      strokeWidth: 3,
    },
  }
}

export {MixedWidget2}